<template>
  <svg
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-full w-full overflow-visible"
  >
    <defs>
      <!-- Subtle soft glow -->
      <filter id="check-glow" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow
          dx="0"
          dy="1"
          stdDeviation="10"
          flood-color="#a78bfa"
          flood-opacity="0.18"
        />
      </filter>

      <!-- Soft radial background -->
      <radialGradient id="check-gradient" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#c4b5fd" stop-opacity="0.14" />
        <stop offset="100%" stop-color="#c4b5fd" stop-opacity="0" />
      </radialGradient>
    </defs>

    <!-- Centered wrapper -->
    <g transform="translate(0, 10)">
      <!-- Back document -->
      <rect
        x="58"
        y="22"
        width="70"
        height="85"
        rx="6"
        fill="#f5f3ff"
        stroke="#ddd6fe"
        stroke-width="1"
      />

      <!-- Front document -->
      <g class="float">
        <rect
          x="68"
          y="30"
          width="70"
          height="85"
          rx="6"
          fill="#f5f3ff"
          stroke="#a78bfa"
          stroke-width="1.25"
        />

        <!-- Document header -->
        <rect x="78" y="42" width="28" height="4" rx="2" fill="#a78bfa" />

        <!-- Text lines -->
        <line
          x1="78"
          y1="56"
          x2="128"
          y2="56"
          stroke="#c4b5fd"
          stroke-width="2"
          stroke-linecap="round"
        />
        <line
          x1="78"
          y1="66"
          x2="122"
          y2="66"
          stroke="#ddd6fe"
          stroke-width="2"
          stroke-linecap="round"
        />
        <line
          x1="78"
          y1="76"
          x2="118"
          y2="76"
          stroke="#ede9fe"
          stroke-width="2"
          stroke-linecap="round"
        />
        <line
          x1="78"
          y1="86"
          x2="110"
          y2="86"
          stroke="#ede9fe"
          stroke-width="2"
          stroke-linecap="round"
        />
      </g>

      <!-- Checkmark badge -->
      <g>
        <!-- Soft glow background -->
        <circle cx="136" cy="93" r="24" fill="url(#check-gradient)" />

        <!-- Glow filter -->
        <g filter="url(#check-glow)">
          <!-- Outer circle -->
          <circle
            cx="136"
            cy="93"
            r="14"
            fill="white"
            stroke="#c4b5fd"
            stroke-width="1.25"
          />

          <!-- Inner circle -->
          <circle cx="136" cy="93" r="10" fill="#7c3aed" />

          <!-- Checkmark -->
          <polyline
            points="131.5,94 135,97 141,90"
            fill="none"
            stroke="white"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="check"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<style scoped>
@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-2px);
  }
}

@keyframes check {
  0% {
    stroke-dashoffset: 20;
  }

  50%,
  100% {
    stroke-dashoffset: 0;
  }
}

.float {
  animation: float 3s ease-in-out infinite;
}

.check {
  animation: check 3s ease-in-out infinite;
}
</style>
